"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var Paragraph_module_scss_1 = __importDefault(require("./styles/Paragraph.module.scss"));
var cn = bind_1.default.bind(Paragraph_module_scss_1.default);
function Paragraph(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.weight, weight = _d === void 0 ? 'thin' : _d, align = _a.align, uppercase = _a.uppercase, emphasis = _a.emphasis, className = _a.className, lightColored = _a.lightColored, dangerouslySetInnerHTML = _a.dangerouslySetInnerHTML;
    return (react_1.default.createElement("p", { dangerouslySetInnerHTML: dangerouslySetInnerHTML, className: cn((_b = {
                paragraph: true
            },
            _b["paragraph__" + size] = Boolean(size),
            _b["paragraph__" + weight] = Boolean(weight),
            _b["paragraph__" + align] = Boolean(align),
            _b.paragraph__uppercase = uppercase,
            _b.paragraph__emphasis = emphasis,
            _b.paragraph__light_colored = lightColored,
            _b), className) }, children));
}
exports.Paragraph = Paragraph;
